import React, { useState, useRef, useEffect } from "react";
import { Button, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./FeedbackPopup.css"; // Import the CSS file
 
interface FeedbackPopupProps {
  isVisible: boolean;
  onClose: () => void;
  onCloseAndDislike: (selectedOptions: string[], description: string) => void; // New prop to handle both actions
  position: {
    top: string;
    left: string;
  };
}
 
 
const FeedbackPopup: React.FC<FeedbackPopupProps> = ({ isVisible, onClose, onCloseAndDislike }) => {
  const [description, setDescription] = useState<string>("");
  const [options, setOptions] = useState([
    { label: "Request not understood", selected: false },
    { label: "Response not correct", selected: false },
    { label: "Response not complete", selected: false },
    { label: "Harmful content", selected: false },
  ]);
 
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisible, onClose]);
 
  const handleOptionToggle = (index: number) => {
    const updatedOptions = options.map((option, i) => ({
      ...option,
      selected: i === index ? !option.selected : option.selected,
    }));
    setOptions(updatedOptions);
  };
 
  const handleSubmit = () => {
    const selectedOptions = options.filter((option) => option.selected).map((option) => option.label);
    console.log("Selected Options:", selectedOptions);
    console.log("Description:", description);
 
    // Call the onCloseAndDislike function to set isDislike to true and close the popup
    onCloseAndDislike(selectedOptions, description);
  };
 
  if (!isVisible) return null; // Don't render the popup if it's not visible
 
  return (
    <div className="feedback-popup" ref={popupRef}>
      <div className="feedback-popup-header">
        <Typography variant="subtitle1" className="feedback-popup-title">
          Can you tell us what happened?
        </Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon className="feedback-popup-close-button" />
        </IconButton>
      </div>
      <Typography variant="caption" component="label" className="feedback-popup-caption">
        You can select multiple options
      </Typography>
      <div className="feedback-popup-options">
        {options.map((option, index) => (
          <Button
            key={index}
            variant="outlined"
            onClick={() => handleOptionToggle(index)}
            className={`feedback-popup-option ${option.selected ? "selected" : ""}`}
          >
            {option.label}
          </Button>
        ))}
      </div>
      <Typography variant="caption" component="label" className="feedback-popup-caption">
        Other:
      </Typography>
      <textarea
        placeholder="Tell us more about the issue"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        rows={2}
        className="feedback-popup-textarea"
      />
      <div className="feedback-popup-buttons">
        <Button
          variant="outlined"
          onClick={onClose}
          className="feedback-popup-button-cancel"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit} // Only the handleSubmit function should be called
          className="feedback-popup-button-submit"
        >
          Submit
        </Button>
      </div>
    </div>
  );
};
 
 
export default FeedbackPopup;